import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BaseQuestionAiChangePreviewComponent } from '../../../bases';
import { useMemo } from 'react';
import { FillInBlankAiChangeStrategyFactory } from './strategies';
import { jsx as _jsx } from "react/jsx-runtime";
export var FillInBlankAiChangePreviewComponent = function FillInBlankAiChangePreviewComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions,
      customDescription = _ref.customDescription;
  var before = states.before,
      after = states.after,
      changeType = states.changeType,
      labels = states.labels;
  var strategy = useMemo(function () {
    return FillInBlankAiChangeStrategyFactory.create({
      changeType: changeType,
      before: before,
      after: after,
      label: {
        badgeNew: labels.badgeNew,
        badgeEdit: labels.badgeEdit,
        badgeDelete: labels.badgeDelete
      }
    });
  }, [changeType, before, after, labels.badgeNew, labels.badgeEdit, labels.badgeDelete]);
  return /*#__PURE__*/_jsx(BaseQuestionAiChangePreviewComponent, {
    states: _objectSpread(_objectSpread({}, states), {}, {
      strategy: strategy,
      customDescription: customDescription
    }),
    actions: actions
  });
};